import { SystemConfigActions } from './systemconfig.actions';

export const SystemConfig = {
  namespaced: true,
  state: () => ({
    globalSettingItem: {},
    odSettingItem: {},
    warSettingItem: {},
    miscSettingItem: {},
    mtgSettingItem: {},
    workStationItem: {},
    devSettingItem: {},
    glSettingItem: {},
    taxSettingItem: {},
    taxWebSettingItem: {},
    resaleSettingItem: {},
    statementSettingItem: {},
    paymentSettingItem: {},
    apportionmentSettingItem: {},
  }),
  mutations: {
    setSettingItem(state, { items, scope }) {
      /* extract & build configuration item */
      const [item] = items;
      const configData = (item && item.configuration) || {};
      configData.id = (item && item.id) || null;
      switch (scope) {
        case 'global':
          state.globalSettingItem = configData || {};
          break;
        case 'odconfig':
          state.odSettingItem = configData || {};
          break;
        case 'warconfig':
          state.warSettingItem = configData || {};
          break;
        case 'miscConfig':
          state.miscSettingItem = configData || {};
          break;
        case 'mtgConfig':
          state.mtgSettingItem = configData || {};
          break;
        case 'devConfig':
          state.devSettingItem = configData || {};
          break;
        case 'glConfig':
          state.glSettingItem = configData || {};
          break;
        case 'taxConfig':
          state.taxSettingItem = configData || {};
          break;
        case 'taxWebConfig':
          state.taxWebSettingItem = configData || {};
          break;
        case 'statementConfig':
          state.statementSettingItem = configData || {};
          break;
        case 'paymentConfig':
          state.paymentSettingItem = configData || {};
          break;
        case 'resaleConfig':
          state.resaleSettingItem = configData || {};
          break;
        case 'apportionmentConfig':
          state.apportionmentSettingItem = configData || {};
          break;
        default:
          break;
      }
    },
    setAfterUpdate(state, { data, scope, newRecordID }) {
      const updatedRecord = { ...data };
      if (newRecordID !== null) {
        updatedRecord.id = newRecordID;
      }
      switch (scope) {
        case 'global':
          state.globalSettingItem = updatedRecord;
          break;
        case 'odconfig':
          state.odSettingItem = updatedRecord;
          break;
        case 'warconfig':
          state.warSettingItem = updatedRecord;
          break;
        case 'miscConfig':
          state.miscSettingItem = updatedRecord;
          break;
        case 'mtgConfig':
          state.mtgSettingItem = updatedRecord;
          break;
        case 'devConfig':
          state.devSettingItem = updatedRecord;
          break;
        case 'glConfig':
          state.glSettingItem = updatedRecord;
          break;
        case 'taxConfig':
          state.taxSettingItem = updatedRecord;
          break;
        case 'taxWebConfig':
          state.taxWebSettingItem = updatedRecord;
          break;
        case 'statementConfig':
          state.statementSettingItem = updatedRecord;
          break;
        case 'paymentConfig':
          state.paymentSettingItem = updatedRecord;
          break;
        case 'resaleConfig':
          state.resaleSettingItem = updatedRecord || {};
          break;
        case 'apportionmentConfig':
          state.apportionmentSettingItem = updatedRecord;
          break;
        default:
          break;
      }
    },
    setWorkstationItem(state, item) {
      state.workStationItem = item;
    },
  },
  actions: {
    ...SystemConfigActions,
  },
};

export default SystemConfig;
